/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { QuestionAnswersModel, QuestionAnswersModelType } from './QuestionAnswersModel'
import { QuestionAnswersModelSelector } from './QuestionAnswersModel.base'
import { RootStoreType } from './index'

/**
 * QuestionsResponseBase
 * auto generated base class for the model QuestionsResponseModel.
 */
export const QuestionsResponseModelBase = ModelBase.named('QuestionsResponse')
  .props({
    __typename: types.optional(types.literal('QuestionsResponse'), 'QuestionsResponse'),
    questions: types.union(types.undefined, types.array(types.late(() => QuestionAnswersModel)))
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class QuestionsResponseModelSelector extends QueryBuilder {
  questions(
    builder:
      | string
      | QuestionAnswersModelSelector
      | ((selector: QuestionAnswersModelSelector) => QuestionAnswersModelSelector)
      | undefined
  ) {
    return this.__child('questions', QuestionAnswersModelSelector, builder)
  }
}
export function selectFromQuestionsResponse() {
  return new QuestionsResponseModelSelector()
}

export const questionsResponseModelPrimitives = selectFromQuestionsResponse()
